<template>
  <div id="invitation">
    <div class="success" v-if="invitation && !noMoreSeatsError">
      <div class="row">
        <div class="col-12">
          <h1 class="title">
            {{
              $t('invitation.registration.title', { companyName: companyName })
            }}
          </h1>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-12">
          <div class="basic-box">
            <div class="row">
              <div class="col-12" v-if="isCompanyInvitation">
                <base-input
                  :placeHolder="$t('invitation.registration.email')"
                  @baseInputValue="emailChanged($event)"
                  @enter="registrate"
                  type="email"
                  :isInvalid="!isEmailValid && email != null"
                  :errorText="$t('registration.modal.email.errorText')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <base-input
                  :placeHolder="$t('invitation.registration.firstName')"
                  @baseInputValue="firstNameChanged($event)"
                  @enter="registrate"
                  :isInvalid="!isFirstNameValid && firstName != null"
                  :errorText="$t('registration.modal.firstName.errorText')"
                />
              </div>
              <div class="col-6">
                <base-input
                  :placeHolder="$t('invitation.registration.lastName')"
                  @baseInputValue="lastNameChanged($event)"
                  @enter="registrate"
                  :isInvalid="!isLastNameValid && lastName != null"
                  :errorText="$t('registration.modal.lastName.errorText')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <base-input
                  :placeHolder="$t('invitation.registration.userName')"
                  @baseInputValue="userNameChanged($event)"
                  @enter="registrate"
                  :isInvalid="!isUserNameValid && userName != null"
                  :errorText="$t('registration.modal.userName.errorText')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <base-input
                  :type="'password'"
                  :placeHolder="$t('registration.modal.password.placeholder')"
                  @baseInputValue="passwordChanged($event)"
                  @enter="registrate"
                  :isInvalid="!isPasswordValid && password != null"
                  :errorText="$t('registration.modal.password.errorText')"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <base-button
                  @click="registrate"
                  :disabled="hasError"
                  :text="$t('invitation.registration.buttonText')"
                  class="col-12"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error" v-else-if="noMoreSeatsError">
        <lottie-player
                  src="/static/images/animations/sorry.json"
                  background="transparent"
                  speed="0.7"
                  style="width: 300px; height: 300px"
                  loop
                  autoplay
                  class=""
                ></lottie-player>
      <div class="error-box">
        Sorry but all seats are full, please contact the team leader to upgrade
        package.
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';
import RegistrationFormMixin from '@/components/shared/users/RegistrationFormMixin';

export default {
  name: 'InvitationScreen',
  mixins: [RegistrationFormMixin],
  components: {
    BaseInput,
    BaseButton,
  },
  data() {
    return {
      invitation: undefined,
      noMoreSeatsError: false,
    };
  },
  async created() {
    if (this.loggedInUserProfile) {
      window.location.href = '/';
    }
    this.fetchInvitation(this.$route.params.code)
      .then((invitation) => {
        this.invitation = invitation;
      })
      .catch((err) => {
        if (err.type && err.type === 'NO_MORE_SEATS') {
          this.noMoreSeatsError = true;
        }
      });
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    isCompanyInvitation() {
      return this.$route.meta.isCompanyInvitation;
    },
    companyName() {
      if (this.isCompanyInvitation) {
        return this.invitation.name;
      }
      return this.invitation.company.name;
    },
  },
  methods: {
    ...mapActions({
      fetchInvitation: 'users/fetchInvitation',
      registrateViaInvitation: 'users/registrateViaInvitation',
    }),
    registrate() {
      if (!this.hasError) {
        this.registrateViaInvitation({
          invitationCode: this.$route.params.code,
          payload: {
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName,
            userName: this.userName,
            email: this.email,
            isCompanyInvitation: this.isCompanyInvitation,
          },
        })
          .then(() => {
            this.$router.push('/');
            this.$eventBus.closeModal();
            this.$swal(
              this.$t('registrate.success.title'),
              this.$t('registrate.success.message'),
              'success'
            );
          })
          .catch((err) => {
            console.log(err);
            this.$swal(
              this.$t('registrate.error.title'),
              this.$t(`server.errors.${err.data.errorCode}`, {
                value: err.data.value,
              }),
              'error'
            );
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#invitation {
  background-position-y: bottom;
  background-size: 100% auto;
  background-repeat: no-repeat;
  height: 100vh;
  overflow: hidden;
  .title {
    margin: 20px 0;
  }
  .form-row {
    max-width: 650px;
    margin: 0 auto;
    .row {
      padding: 10px 0;
    }
  }
  .error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    flex-direction: column;
    .error-box {
      color: $secondary-color;
      font-size: 1.5rem;
      max-width: 40%;
      font-weight: bolder;
      border: 2px dashed $secondary-color !important;
      border-radius: 8px;
      padding: 20px;
    }
  }
}
</style>
